import React, {useEffect, useState} from 'react'
import ClientSuspense from '@components/ClientSuspense'
import useSessionStorageState from '@hooks/useSessionStorageState'
import getEnv from '@providers/getEnv'
import dynamic from 'next/dynamic'

import {DELAY_BEFORE_DISPLAY, SHOW_ONLY_IN_PROD} from './constants'
import useShouldShowForm from './useShouldShowForm'

const Content = dynamic(() => import('./Content'))

function TypeformDelayed() {
  const [mounted, setMounted] = React.useState(false)
  const [_, setFormShown] = useSessionStorageState('trackingv2-typeform-shown', false)

  useEffect(() => {
    setTimeout(() => {
      setMounted(true)
      setFormShown('true')
    }, DELAY_BEFORE_DISPLAY)
  }, [])

  if (!mounted) return null

  return <Content />
}

function TypeformInner() {
  const shouldShow = useShouldShowForm()

  if (!shouldShow) return null

  return <TypeformDelayed />
}

export default function Typeform() {
  const [formShown] = useSessionStorageState('trackingv2-typeform-shown', false)
  const [formShownOnMount] = useState(formShown)

  if (formShownOnMount === 'true') return null
  if (SHOW_ONLY_IN_PROD && getEnv() !== 'prod') return null

  return (
    <ClientSuspense fallback={null}>
      <TypeformInner />
    </ClientSuspense>
  )
}
